function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.757.813c0-.445.075-.813.54-.813.456 0 .72.368.72.813l.559 5.687c0 1.16-.51 2.188-1.31 2.925l.032-.01a2.04 2.04 0 0 1-.146.128l-.028.023a1.447 1.447 0 0 1-.016.01c-.024.016-.04.026-.049.044-.433.357-.346 1.69-.346 1.69v13.065c0 .834-.661 1.517-1.506 1.603L8.033 26l-.173-.022c-.845-.076-1.506-.758-1.506-1.603V11.332c0-.125.002-.24.003-.348.008-.675.013-1.057-.36-1.375l-.033-.032-.067-.054a1.498 1.498 0 0 1-.128-.109l.033.011C5 8.688 4.49 7.659 4.49 6.5L4.96.812C4.962.368 5.2 0 5.655 0c.465 0 .627.368.627.813l-.11 5.503c0 .693.248 1.31.67 1.776 0 0 .358.358.358-.325L7.365.813c0-.444.213-.812.668-.812.466 0 .702.368.691.813l.144 6.955c.01.682.368.303.368.303.412-.466.66-1.083.66-1.766L9.758.813zM20.043 0a.46.46 0 0 0-.348.15c-.793.882-4.711 5.648-4.877 13.93-.006.3.237.545.536.545h2.265c.3 0 .542.242.542.542v9.208c0 .897.75 1.625 1.674 1.625.924 0 1.674-.728 1.674-1.625V.812A.825.825 0 0 0 20.672 0h-.63z",
  fill: "#004152"
});

var SvgMeals = function SvgMeals(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMeals, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/meals.4028963c.svg";
export { ForwardRef as ReactComponent };